<template>
  <div class="filter-menu" @click.self="close()">
    <div class="filter-container">
      <div class="filter-header">
        <h3 class="filter-title">{{title}}</h3>
        <font-awesome-icon
          style="cursor: pointer"
          :icon="['fas', 'window-close']"
          @click="close()"
        />
      </div>
      <div class="filter-options">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    title:{
      required:false,
      value: String,
      default: () => "Control Options"
    }
  },
  mounted(){
    this.$store.commit("setFilterOpen", true)
  },
  methods:{
    close(){
      this.$store.commit("setFilterOpen", false)
      this.$emit('closeFilters')
    }
  }
};
</script>

<style scoped>
.filter-menu {
  pointer-events: auto; 
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.4);
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
  z-index: 20;
}

.filter-container {
  background-color: white;
  max-height:80vh;
  overflow-y:auto;
  overflow-x:hidden;
  border-radius:6px;
}

.filter-options {
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align:left;
}

.filter-options > * {
  margin: 5px;
}

.filter-header {
  padding: 10px;
  display: flex;
  justify-content: space-between;
}

.filter-title {
  text-align: left;
  font-weight: bold;
  font-size: 16pt;
}
</style>